import React, { useState, useCallback, useMemo } from "react";

import { motion } from "framer-motion";

import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";

import "leaflet/dist/leaflet.css";

import L from "leaflet";

import toast from "react-hot-toast";

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import TravelExploreIcon from '@mui/icons-material/TravelExplore';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import PersonAddIcon from "@mui/icons-material/PersonAdd";

import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import MapIcon from '@mui/icons-material/Map';

import NotificationsIcon from '@mui/icons-material/Notifications';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import AddIcon from '@mui/icons-material/Add';

import { ArrowBack, Mail } from "@mui/icons-material";

import VoterPledge from "../components/VoterPledge";
import ElectionReminders from "../components/ElectionReminders";
import ElectionDates from "../components/ElectionDates";

import ConfirmationSuccess from "../components/ConfirmationSuccess";

import { useApiMutation } from "../hooks/useMutation";
import { useApiQuery } from "../hooks/useApiQuery";

import { usePollingLocations } from "../hooks/usePollingLocations";

import Button from "../utils/Button";
import { US_STATES } from "../utils/Constant";

import axios from "axios";
import { useSearchParams } from "react-router-dom";



const states = [

  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",

  "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",

  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",

  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",

  "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",

  "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",

  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"

];

const apiUrl = process.env.REACT_APP_API_URL;







delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({

  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',

  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',

  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',

});



const MapController = ({ center, zoom }: { center: [number, number]; zoom: number }) => {

  const map = useMap();



  React.useEffect(() => {

    if (center && center[0] && center[1]) {

      map.setView(center, zoom);

    }

  }, [center, zoom, map]);



  return null;

};



type EmbedFeatures = {

  email_reminders?: boolean;

  sms_reminders?: boolean;

  advanced_automation?: boolean;

};



type CheckRegistrationProps = {

  embedMode?: boolean;

  partnerId?: string;

  features?: EmbedFeatures;

};

type RegistrationFieldErrors = Partial<Record<
  "firstName" | "lastName" | "state" | "zipcode" | "city" | "address" | "phone" | "email" | "dob" | "gender" | "reminder",
  string
>>;

interface ElectionData {
  elections: Array<{
    id: number;
    googleElectionId: string;
    name: string;
    electionDay: string;
    ocdDivisionId: string;
    electionType: 'GENERAL' | 'PRIMARY' | 'SPECIAL';
    stateCode: string;
    electionHours: string | null;
    registrationDeadline: string | null;
    mailRequestDeadline: string | null;
    mailReturnDeadline: string | null;
    earlyVotingStartDate: string | null;
    earlyVotingEndDate: string | null;
    voterIdRequirement: string | null;
    felonyVotingRules: string | null;
    electionInfoUrl: string;
    electionRegistrationUrl: string;
    electionRegistrationConfirmationUrl: string;
    absenteeVotingInfoUrl: string;
    votingLocationFinderUrl: string;
    ballotInfoUrl: string | null;
    electionRulesUrl: string;
    officialStateWebsite: string;
    voterInfoEnriched: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
  state: {
    'SOS/DataEndpoint': string;
    'RegistrationLookupUrl': string;
    'VoteByMailUrl': string;
    'VoteByMailOnlineAllowed': string;
  };
}

interface ElectionApiResponse {
  data: ElectionData;
}



export default function CheckRegistration({

  embedMode = false,

  partnerId,

  features,

}: CheckRegistrationProps) {
  const [searchParams] = useSearchParams();

  const smsRemindersEnabled = features?.sms_reminders !== false;
  const embedIdFromPage = searchParams.get("embed_id") || window.sessionStorage.getItem("embedded_partner_id") || "";
  const isEmbeddedFlow = embedMode || searchParams.get("embed") === "true" || !!embedIdFromPage;

  const getStateCode = useCallback((stateName: string): string => {
    const state = US_STATES.find((s) => s.name === stateName);
    return state?.code || stateName;
  }, []);


  const [currentStep, setCurrentStep] = useState(0);

  const [isFlowActive, setIsFlowActive] = useState(false);



  const [form, setForm] = useState({

    firstName: "",

    lastName: "",

    address: "",

    city: "",

    state: "",

    zipcode: "",

    phone: "",

    email: "",

    dob: "",

    gender: "",

    reminder: false,
    emailReminders: false,
    textReminders: false,
    reminder7Days: false,
    reminder1Day: false,
    reminderElectionDay: false,

    voterPledge: false,

  });
  const [formErrors, setFormErrors] = useState<RegistrationFieldErrors>({});



  const [registrationResult, setRegistrationResult] = useState<any>(null);

  const [showReturnFlow, setShowReturnFlow] = useState(false);

  const [registrationCompleted, setRegistrationCompleted] = useState(false);

  const [currentFlow, setCurrentFlow] = useState<'polling' | 'reminders' | 'dates' | null>(null);



  const [showRegistrationStatusPage, setShowRegistrationStatusPage] = useState(false);

  const [selectedRegistrationStatus, setSelectedRegistrationStatus] = useState<string | null>(null);
  const [isFromNotSureFlow, setIsFromNotSureFlow] = useState(false);

  const [showNotRegisteredModal, setShowNotRegisteredModal] = useState(false);

  const [showCompletionCheckModal, setShowCompletionCheckModal] = useState(false);

  const [showContactOptIn, setShowContactOptIn] = useState(false);

  const [contactOptInChecked, setContactOptInChecked] = useState(false);

  const [showConfirmation, setShowConfirmation] = useState(false);



  // VBM flow state variables

  const [showVBMCompletionModal, setShowVBMCompletionModal] = useState(false);

  const [showVBMOptInModal, setShowVBMOptInModal] = useState(false);

  const [showVBMRetryModal, setShowVBMRetryModal] = useState(false);

  const [vbmOptIns, setVbmOptIns] = useState({

    mailBallotReminders: false,

    ballotTracking: false,

    returnDeadlineReminders: false

  });



  // VBM status update mutation

  const vbmStatusUpdateMutation = useApiMutation({

    onSuccess: () => {

      console.log('VBM status updated successfully');

    },

    onError: (error: any) => {

      console.error('VBM status update error:', error);

    },

  });



  // VBM opt-in mutation

  const vbmOptInMutation = useApiMutation({

    onSuccess: (response: { message?: string }) => {

      console.log('VBM opt-in successful');

      toast.success(response?.message || 'VBM opt-in successful');

    },

    onError: (error: unknown) => {

      console.error('VBM opt-in error:', error);

      const errorMessage =

        (error as any)?.response?.data?.message ||

        (error as any)?.message ||

        'VBM opt-in failed';

      toast.error(errorMessage);

    },

  });



  const { data: pollingLocationsData, isLoading: isPollingLoading, error: pollingError, refetch: refetchPollingLocations } = usePollingLocations({

    address: form.address,

    city: form.city,

    state: form.state,

    zipcode: form.zipcode,

    enabled: currentStep === 3 && currentFlow === 'polling' && !!(form.address && form.city && form.state && form.zipcode),

  });



  const pollingLocations = pollingLocationsData?.data?.pollingLocations || [];

  const { data: electionData, isLoading: isElectionLoading, error: electionError } = useApiQuery<ElectionApiResponse>({
    queryKey: ['electionData', form.state],
    request: {
      method: 'GET',
      url: `/elections/state/${getStateCode(form.state)}`,
    },
    enabled: currentStep === 3 && currentFlow === 'dates' && !!form.state,
  });







  const startFlow = () => {

    setIsFlowActive(true);
    setIsFromNotSureFlow(false);

    setCurrentStep(1);

  };



  const nextStep = () => {

    setCurrentStep(prev => Math.min(prev + 1, 4));

  };



  const previousStep = () => {

    setCurrentStep(prev => Math.max(prev - 1, 1));

  };



  const endFlow = () => {

    setIsFlowActive(false);
    setIsFromNotSureFlow(false);

    setCurrentStep(0);

    setForm({

      firstName: "",

      lastName: "",

      address: "",

      city: "",

      state: "",

      zipcode: "",

      phone: "",

      email: "",

      dob: "",

      gender: "",

      reminder: false,
      emailReminders: false,
      textReminders: false,
      reminder7Days: false,
      reminder1Day: false,
      reminderElectionDay: false,

      voterPledge: false,

    });

  };



  const getAgeFromDob = (dob: string): number => {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    if (Number.isNaN(birthDate.getTime())) return 0;
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const hasBirthdayPassedThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
    if (!hasBirthdayPassedThisYear) age -= 1;
    return age;
  };

  const requiredFieldMessages: Partial<Record<keyof RegistrationFieldErrors, string>> = {
    firstName: "First name is required",
    lastName: "Last name is required",
    state: "State is required",
    zipcode: "Zipcode is required",
    city: "City is required",
    address: "Home address is required",
    email: "Email address is required",
    gender: "Gender is required",
  };

  const getFieldError = (name: keyof RegistrationFieldErrors, value: string | boolean): string => {
    if (name === "dob") {
      const dobValue = String(value).trim();
      if (!dobValue) return "Date of birth is required";
      return getAgeFromDob(dobValue) < 16 ? "Voter must be 16 years old to be eligible" : "";
    }
    const requiredMessage = requiredFieldMessages[name];
    if (!requiredMessage) return "";
    return String(value).trim() ? "" : requiredMessage;
  };

  const validateRegistrationForm = (): RegistrationFieldErrors => {
    const errors: RegistrationFieldErrors = {};
    if (!form.firstName.trim()) errors.firstName = "First name is required";
    if (!form.lastName.trim()) errors.lastName = "Last name is required";
    if (!form.address.trim()) errors.address = "Home address is required";
    if (!form.city.trim()) errors.city = "City is required";
    if (!form.state.trim()) errors.state = "State is required";
    if (!form.zipcode.trim()) errors.zipcode = "Zipcode is required";
    if (!form.email.trim()) errors.email = "Email address is required";
    if (!form.dob.trim()) {
      errors.dob = "Date of birth is required";
    } else if (getAgeFromDob(form.dob) < 16) {
      errors.dob = "Voter must be 16 years old to be eligible";
    }
    if (!form.gender.trim()) errors.gender = "Gender is required";
    return errors;
  };

  const mapBackendFieldToFormField = (fieldKey: string): keyof RegistrationFieldErrors | null => {
    const fieldMap: Record<string, keyof RegistrationFieldErrors> = {
      firstName: "firstName",
      lastName: "lastName",
      state: "state",
      zipcode: "zipcode",
      zip: "zipcode",
      city: "city",
      address: "address",
      phone: "phone",
      phoneNumber: "phone",
      email: "email",
      dob: "dob",
      gender: "gender",
      reminder: "reminder",
    };
    return fieldMap[fieldKey] || null;
  };



  const handleChange = useCallback(

    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {

      const { name, value, type } = e.target;

      setForm((f: any) => ({

        ...f,

        [name]: type === "checkbox" ? (e.target as HTMLInputElement).checked : value,

      }));
      const formFieldName = name as keyof RegistrationFieldErrors;
      setFormErrors((prev) => {
        if (!prev[formFieldName]) return prev;
        return { ...prev, [formFieldName]: getFieldError(formFieldName, type === "checkbox" ? (e.target as HTMLInputElement).checked : value) };
      });

    },

    []

  );



  const handleGender = useCallback(

    (gender: string) => {

      setForm((f: any) => ({ ...f, gender }));
      setFormErrors((prev) => ({ ...prev, gender: getFieldError("gender", gender) }));

    },

    []

  );



  const handleRegistrationCheck = useCallback(async () => {
    const validationErrors = validateRegistrationForm();
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors);
      if (validationErrors.dob === "Voter must be 16 years old to be eligible") {
        toast.error("Voter must be 16 years old to be eligible");
      } else {
        toast.error("Please fill all required fields");
      }
      return;
    }
    setFormErrors({});



    try {
      const trimmedPhone = form.phone.trim();
      const payload = {
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        address: form.address.trim(),
        city: form.city.trim(),
        state: form.state,
        zipcode: form.zipcode.trim(),
        ...(trimmedPhone ? { phone: trimmedPhone } : {}),
        email: form.email.trim(),
        dob: form.dob,
        gender: form.gender ? form.gender.toUpperCase() : "",
        reminder: form.reminder,
        // partnerId,
        // source: embedMode ? "EMBED_WIDGET" : "WEB_PORTAL",
      };

      const response = await fetch(`${apiUrl}/registration-check`, {

        method: "POST",

        headers: {
          "Content-Type": "application/json",
          ...(isEmbeddedFlow && embedIdFromPage ? { "x-embed-id": embedIdFromPage } : {}),
        },

        body: JSON.stringify(payload),

      });



      const result = await response.json();
      if (!response.ok) {
        const backendValidationErrors = result?.data;
        const normalizedErrors: RegistrationFieldErrors = {};
        let hasValidationErrors = false;

        if (backendValidationErrors && typeof backendValidationErrors === "object") {
          Object.entries(backendValidationErrors).forEach(([fieldKey, message]) => {
            const fieldName = mapBackendFieldToFormField(fieldKey);
            const messageText = typeof message === "string" ? message : "Invalid value";
            if (fieldName) {
              normalizedErrors[fieldName] = messageText;
              hasValidationErrors = true;
            }
            toast.error(messageText);
          });
        }

        if (hasValidationErrors) {
          setFormErrors(normalizedErrors);
          return;
        }

        toast.error(result?.message || "Registration check failed. Please try again.");
        return;
      }

      setRegistrationResult(result);



      if (result.redirectUrl) {

        nextStep(); // Go to step 2 (state registration)

      } else {

        nextStep(); // Go to step 2

        nextStep(); // Skip to step 3 (already registered)

      }

    } catch (error) {

      toast.error('Registration check failed. Please try again.');

    }

  }, [form, apiUrl, partnerId, embedMode, smsRemindersEnabled, isEmbeddedFlow, embedIdFromPage]);



  const handleOpenStateWebsite = useCallback(() => {

    // Open the state website in a new small tab

    if (registrationResult?.redirectUrl) {

      window.open(registrationResult.redirectUrl, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    }

    // Immediately proceed to the next step after opening the tab

    setRegistrationCompleted(true);

    setShowRegistrationStatusPage(true);

  }, [registrationResult]);





  const handleReturnFlowOption = useCallback((option: string) => {

    setShowReturnFlow(false);

    switch (option) {

      case 'polling':

        setCurrentFlow('polling');

        setCurrentStep(3);

        break;

      case 'reminders':

        setCurrentFlow('reminders');

        setCurrentStep(3);

        break;

      case 'dates':

        setCurrentFlow('dates');

        setCurrentStep(3);

        break;

      case 'vbm':

        // Open the VBM website in a new small tab
        if (registrationResult?.voteByMailUrl) {
          console.log('Opening VBM URL');
          window.open(registrationResult.voteByMailUrl, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        } else {
          console.log('No VBM URL available');
        }

        // Immediately proceed to the next step after opening the tab
        setShowVBMCompletionModal(true);

        break;

      case 'exit':

        setCurrentFlow(null);

        setShowConfirmation(true);

        setCurrentStep(4);

        break;

    }

  }, [registrationResult]);



  const registrationStatusUpdateMutation = useApiMutation({

    onSuccess: () => {

      console.log("Registration status updated successfully");

      toast.success("Registration status updated successfully")

    },

    onError: (error: any) => {

      const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update registration status.';

      toast.error(errorMessage);

    },

  });

  const pledgeToVoteMutation = useApiMutation({

    onSuccess: () => {

      toast.success("Pledge saved successfully");

    },

    onError: (error: any) => {

      const errorMessage = error?.response?.data?.message || error?.message || 'Failed to save pledge to vote.';

      toast.error(errorMessage);

    },

  });

  const contactOptInMutation = useApiMutation<{
    message?: string;
  }>({});



  const handleRegistrationStatusUpdate = useCallback((status: string) => {


    if (registrationResult?.registration?.id) {

      let isRegistered = false;

      let selfReportedStatus = 'NOT_SURE';



      if (status === 'registered') {

        isRegistered = true;

        selfReportedStatus = 'REGISTERED';

      } else if (status === 'not_registered') {

        isRegistered = false;

        selfReportedStatus = 'NOT_REGISTERED';

      } else if (status === 'not_sure') {

        isRegistered = false;

        selfReportedStatus = 'NOT_SURE';

      }



      const submissionData = {

        url: `/registration-check/${registrationResult.registration.id}`,

        method: "PUT",

        data: {

          isRegistered,

          selfReportedStatus

        },

      };

      registrationStatusUpdateMutation.mutate(submissionData);

    }

  }, [registrationResult, registrationStatusUpdateMutation]);



  const handleRegistrationStatusSelection = useCallback((status: string) => {

    setSelectedRegistrationStatus(status);

    handleRegistrationStatusUpdate(status);

    if (status === 'registered') {
      setIsFromNotSureFlow(false);

      setShowRegistrationStatusPage(false);

      setShowReturnFlow(true);

    } else if (status === 'not_registered') {
      setIsFromNotSureFlow(false);

      setShowRegistrationStatusPage(false);

      setShowNotRegisteredModal(true);

    } else if (status === 'not_sure') {
      setIsFromNotSureFlow(true);

      setShowRegistrationStatusPage(false);
      setContactOptInChecked(false);
      setShowContactOptIn(true);

    }

  }, [handleRegistrationStatusUpdate]);



  const handleRegisterOnStateSite = useCallback(() => {

    setShowNotRegisteredModal(false);

    // Open the state website in a new small tab

    if (registrationResult?.redirectUrl) {

      window.open(registrationResult.redirectUrl, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    }

    // Immediately proceed to the next step after opening the tab

    setShowCompletionCheckModal(true);

  }, [registrationResult]);





  const handleCompletionCheckResponse = useCallback((completed: boolean) => {

    setShowCompletionCheckModal(false);

    if (completed) {

      handleRegistrationStatusUpdate('registered');

      setShowReturnFlow(true);

    } else {

      handleRegistrationStatusUpdate('not_registered');
      setContactOptInChecked(false);
      setShowContactOptIn(true);

    }

  }, [handleRegistrationStatusUpdate]);

  const proceedToReturnFlow = useCallback(() => {
    setShowContactOptIn(false);
    setContactOptInChecked(false);
    setShowReturnFlow(true);
  }, []);

  const handleContactOptInSkip = useCallback(() => {
    proceedToReturnFlow();
  }, [proceedToReturnFlow]);

  const handleContactOptInSubmit = useCallback(() => {
    const checkRegistrationLogId = registrationResult?.registration?.id;

    if (!checkRegistrationLogId) {
      toast.error('Missing registration id for sending the official registration link.');
      proceedToReturnFlow();
      return;
    }

    const trimmedEmail = form.email.trim();
    const trimmedPhone = form.phone.trim();
    const contactOptInPayload = {
      checkRegistrationLogId,
      bymail: !!trimmedEmail,
      bysms: !!trimmedPhone,
    };

    contactOptInMutation.mutate(
      {
        url: '/registration-check/send-links',
        method: 'POST',
        data: contactOptInPayload,
      },
      {
        onSuccess: () => {
          toast.success("We'll send the official registration link.");
          proceedToReturnFlow();
        },
        onError: (error: any) => {
          const errorMessage = error?.response?.data?.message || error?.message || 'Failed to save contact preference.';
          toast.error(errorMessage);
          proceedToReturnFlow();
        },
      }
    );
  }, [contactOptInMutation, form.email, form.phone, proceedToReturnFlow, registrationResult]);



  const updateForm = useCallback((patch: any) => {

    setForm(prev => ({ ...prev, ...patch }));

  }, []);



  // VBM flow handlers



  const handleVBMCompletionResponse = useCallback((response: string) => {

    setShowVBMCompletionModal(false);



    // Make API call to update VBM status immediately

    const statusMap: Record<string, string> = {

      'requested': 'REQUESTED',

      'didnt_complete': 'NOT_COMPLETED',

      'not_eligible': 'NOT_ELIGIBLE'

    };



    const status = statusMap[response];



    const updateVBMStatus = () => {


      if (status && registrationResult?.registration?.id) {

        const submissionData = {

          url: `/vote-by-mail/${registrationResult.registration.id}`,

          method: 'POST',

          data: {

            status: status,

            signOnSource: 'WEB PORTAL'

          }

        };

        vbmStatusUpdateMutation.mutate(submissionData);

      }

    };



    if (response === 'requested') {

      updateVBMStatus();

      setShowVBMOptInModal(true);

    } else if (response === 'didnt_complete') {

      updateVBMStatus();

      setShowVBMRetryModal(true);

    } else if (response === 'not_eligible') {

      updateVBMStatus();

      setShowReturnFlow(true)

      nextStep();

    }

  }, [nextStep, registrationResult, vbmStatusUpdateMutation]);



  const handleVBMRetryReturn = useCallback(() => {

    setShowVBMRetryModal(false);

    // Reopen the VBM website in a new small tab

    if (registrationResult?.voteByMailUrl) {

      window.open(registrationResult.voteByMailUrl, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    }

    // Show the completion modal again after opening the tab

    setShowVBMCompletionModal(true);

  }, [registrationResult]);



  const handleVBMOptInSubmit = useCallback(() => {

    setShowVBMOptInModal(false);



    const enabled = [];

    if (vbmOptIns.mailBallotReminders) enabled.push('MAIL_BALLOT_REMINDERS');

    if (vbmOptIns.ballotTracking) enabled.push('MAIL_BALLOT_TRACKING_INFO');

    if (vbmOptIns.returnDeadlineReminders) enabled.push('MAIL_BALLOT_DEADLINE');





    if (enabled.length > 0) {

      const optInData = {

        url: `/vote-by-mail/${registrationResult?.registration?.id}`,

        method: 'PUT',

        data: {

          reminderOptions: enabled

        }

      };

      vbmOptInMutation.mutate(optInData);

    }



    // Take to pledge to vote stage

    setShowConfirmation(true);

    nextStep();

    nextStep();

  }, [vbmOptIns, form, nextStep, vbmOptInMutation]);



  const handleVBMOptInChange = useCallback((option: string, checked: boolean) => {

    setVbmOptIns(prev => ({

      ...prev,

      [option]: checked

    }));

  }, []);

  const handlePledgeSubmit = useCallback(() => {

    if (!form.voterPledge) {

      setShowConfirmation(true);

      return;

    }

    const checkRegistrationLogId = registrationResult?.registration?.id;

    if (!checkRegistrationLogId) {

      toast.error('Missing registration id for pledge to vote.');

      return;

    }

    pledgeToVoteMutation.mutate({

      url: "/pledge-to-vote",

      method: "POST",

      data: {

        checkRegistrationLogId,

      },

    }, {

      onSuccess: () => {

        setShowConfirmation(true);

      },

    });

  }, [form.voterPledge, registrationResult, pledgeToVoteMutation]);



    const isInIframe = window.self !== window.top;






  return (

    <section

      className="min-h-screen flex flex-col items-center pt-12 pb-12 px-2"

      style={{

        background: "linear-gradient(135deg, #e0e7ff 0%, #fafafa 80%)",

        minHeight: "100vh",

      }}

    >
      {isInIframe && <div className="flex items-center gap-2 cursor-pointer absolute top-5 left-5  text-sm" onClick={() => window.history.back()}>
        <ArrowBack /> Go back
      </div>}

      {!isFlowActive ? (

        <div className="w-full max-w-4xl mx-auto space-y-8">

          <div className="text-center">

            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">

              Check Your Voter Registration

            </h1>

            <p className="text-xl text-gray-600 mb-8">

              Verify your registration status and get ready to vote

            </p>

          </div>



          <div className="bg-white rounded-xl shadow-lg p-8">

            <div className="text-center">

              <button

                onClick={startFlow}

                className="w-24 h-24 bg-blue-600 hover:bg-blue-700 text-white rounded-full flex items-center justify-center mx-auto mb-6 transition-all duration-200 transform hover:scale-105 shadow-lg"

              >

                <PersonAddIcon style={{ fontSize: 36 }} />

              </button>

              <h2 className="text-2xl font-semibold mb-3">Start Registration Check</h2>

              <p className="text-gray-600 max-w-md mx-auto">

                Ready to check your voter registration status? Tap the button to begin.

              </p>

            </div>

          </div>

        </div>

      ) : (

        // Multi-step flow

        <div className="w-full max-w-2xl mx-auto">

          {/* Header */}

          <div className="flex items-center justify-between mb-6">

            <div className="flex items-center gap-3">

              <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>

              <span className="text-green-600 font-medium">Active Session</span>

            </div>

            <button

              onClick={endFlow}

              className="text-gray-500 hover:text-gray-700 text-sm font-medium"

            >

              End Session

            </button>

          </div>



          {/* Progress indicator */}

          <div className="mb-8">

            <div className="flex items-center justify-between mb-2">

              <span className="text-sm font-medium text-gray-500">STEP {currentStep} OF 4</span>

              <span className="text-sm font-medium text-gray-900">

                {currentStep === 1 && 'Registration Check'}

                {currentStep === 2 && 'State Registration'}

                {currentStep === 3 && currentFlow === 'polling' && 'Polling Location'}

                {currentStep === 3 && currentFlow === 'reminders' && 'Election Reminders'}

                {currentStep === 3 && currentFlow === 'dates' && 'Voting Dates'}

                {currentStep === 4 && 'Complete'}

              </span>

            </div>

            <div className="w-full bg-gray-200 rounded-full h-2">

              <div

                className="bg-blue-600 h-2 rounded-full transition-all duration-300"

                style={{ width: `${(currentStep / 4) * 100}%` }}

              ></div>

            </div>

          </div>



          {/* Step content */}

          {currentStep === 1 && (

            <div className="bg-white rounded-xl shadow-lg p-6">

              <h2 className="text-2xl text-gray-900 font-semibold mb-2">Check Your Registration Status</h2>

              <p className="text-gray-600 text-sm mb-6">Enter your information below to look up your voter registration using official state sources.</p>



              {/* Registration Form */}

              <div className="md:grid grid-cols-1 md:grid-cols-3 space-y-4 md:space-y-0 gap-6 text-black">

                <div>

                  <label className="font-semibold">First Name <span className="text-red-600">*</span></label>

                  <input

                    type="text"

                    name="firstName"

                    value={form.firstName}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder="First Name"

                    required

                  />
                  {formErrors.firstName && <p className="text-red-600 text-xs mt-1">{formErrors.firstName}</p>}

                </div>

                <div>

                  <label className="font-semibold">Last Name <span className="text-red-600">*</span></label>

                  <input

                    type="text"

                    name="lastName"

                    value={form.lastName}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder="Last Name"

                    required

                  />
                  {formErrors.lastName && <p className="text-red-600 text-xs mt-1">{formErrors.lastName}</p>}

                </div>

                <div>

                  <label className="font-semibold">State <span className="text-red-600">*</span></label>

                  <select

                    name="state"

                    value={form.state}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600 bg-white"

                    required

                  >

                    <option value="">Select State</option>

                    {states.map((s) => (

                      <option key={s} value={s}>{s}</option>

                    ))}

                  </select>
                  {formErrors.state && <p className="text-red-600 text-xs mt-1">{formErrors.state}</p>}

                </div>

                <div>

                  <label className="font-semibold">Zipcode <span className="text-red-600">*</span></label>

                  <input

                    type="text"

                    name="zipcode"

                    value={form.zipcode}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder="Zipcode"

                    required

                  />
                  {formErrors.zipcode && <p className="text-red-600 text-xs mt-1">{formErrors.zipcode}</p>}

                </div>

                <div>

                  <label className="font-semibold">City <span className="text-red-600">*</span></label>

                  <input

                    type="text"

                    name="city"

                    value={form.city}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder="City"

                    required

                  />
                  {formErrors.city && <p className="text-red-600 text-xs mt-1">{formErrors.city}</p>}

                </div>

                <div>

                  <label className="font-semibold">Home Address <span className="text-red-600">*</span></label>

                  <input

                    type="text"

                    name="address"

                    value={form.address}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder="123 Main St"

                    required

                  />
                  {formErrors.address && <p className="text-red-600 text-xs mt-1">{formErrors.address}</p>}

                </div>

                <div>

                  <label className="font-semibold">Phone Number</label>

                  <input

                    type="text"

                    name="phone"

                    value={form.phone}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder={smsRemindersEnabled ? "Phone Number (Optional)" : "Unavailable in this partner plan"}

                    disabled={!smsRemindersEnabled}

                  />
                  {formErrors.phone && <p className="text-red-600 text-xs mt-1">{formErrors.phone}</p>}

                </div>

                <div>

                  <label className="font-semibold">Email Address <span className="text-red-600">*</span></label>

                  <input

                    type="email"

                    name="email"

                    value={form.email}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    placeholder="Email Address"

                    required

                  />
                  {formErrors.email && <p className="text-red-600 text-xs mt-1">{formErrors.email}</p>}

                </div>

                <div>

                  <label className="font-semibold">Date of Birth <span className="text-red-600">*</span></label>

                  <input

                    type="date"

                    name="dob"

                    value={form.dob}

                    onChange={handleChange}

                    className="w-full border border-gray-400 rounded px-3 py-2 mt-1 transition-all focus:border-red-600"

                    required

                  />
                  {formErrors.dob && <p className="text-red-600 text-xs mt-1">{formErrors.dob}</p>}

                </div>

                <div className="flex items-center mt-4 space-x-8 col-span-2">

                  <label className="font-semibold">Gender: <span className="text-red-600">*</span></label>

                  <label className="flex items-center space-x-2">

                    <input type="radio" name="gender" checked={form.gender === "Male"} onChange={() => handleGender("Male")} />

                    <span>Male</span>

                  </label>

                  <label className="flex items-center space-x-2">

                    <input type="radio" name="gender" checked={form.gender === "Female"} onChange={() => handleGender("Female")} />

                    <span>Female</span>

                  </label>
                  {formErrors.gender && <p className="text-red-600 text-xs mt-1">{formErrors.gender}</p>}

                </div>

              </div>

              <p className="text-gray-600 text-sm mt-3">Your information is used only to perform this lookup and is not stored as a voter profile</p>



              {/* Election Reminders */}

              <div className="flex flex-col space-y-2 text-black mt-6">

                <label className="flex items-center space-x-2">

                  <input

                    type="checkbox"

                    name="reminder"

                    checked={form.reminder}

                    onChange={handleChange}

                  />

                  <span className="font-semibold">Receive election reminders and action alerts updates from 123-Vote.</span>

                </label>

                <div className="text-xs text-gray-400 mt-1 pl-8 italic">

                  {smsRemindersEnabled

                    ? 'By entering your phone number and pressing "Check your registration", you consent to receive periodic text and email about voting information support from 123-Vote. Message and data rates may apply. Text STOP to opt out at any time. You may unsubscribe from email at any time.'

                    : 'By pressing "Check your registration", you consent to receive periodic email about voting information support from 123-Vote. You may unsubscribe from email at any time.'}

                </div>

              </div>



              <div className="flex justify-between mt-8">

                <button

                  onClick={previousStep}

                  disabled={currentStep === 1}

                  className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"

                >

                  Back

                </button>

                <button

                  onClick={handleRegistrationCheck}

                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"

                >

                  Check Status

                </button>

              </div>



              <div className="mt-6 pt-4 border-t border-gray-200">

                <p className="text-xs text-gray-500 text-center">

                  Information is sent securely to public election systems or official state websites.

                </p>

              </div>

            </div>

          )}



          {currentStep === 2 && registrationResult?.redirectUrl && (

            <div className="bg-white rounded-xl shadow-lg p-10">

              <div className="bg-rose-600 rounded-full p-2 flex justify-center items-center m-auto w-fit animate-pulse text-white">

                <TravelExploreIcon fontSize="large" />

              </div>

              <h1 className="text-2xl text-gray-900 font-semibold mb-2 capitalize text-center">Check my registration <br />on the official state site</h1>

              <h2 className="text-sm text-gray-900 font-semibold mb-2 text-center">You can only register using your state official website</h2>

              <p className="text-gray-600 text-xs text-center mb-6">

                You'll be taken to the official state election website to check your registration status.

              </p>



              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">

                <div className="flex items-start space-x-3">

                  <svg className="w-5 h-5 text-blue-600 mt-0.5" fill="none" viewBox="0 0 24 24">

                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />

                  </svg>

                  <div>

                    <h3 className="font-semibold text-blue-900 mb-2">Important Information</h3>

                    <ul className="text-sm text-blue-800 space-y-1">

                      <li>• 123Vote does not register voters directly!</li>

                      <li>• Your registration will be completed on a government-run site</li>

                      <li>• 123Vote does not control or store state registration data</li>

                      <li>• You can return after you're done</li>

                    </ul>

                  </div>

                </div>

              </div>



              <div className="space-y-4">

                <div className="p-4 bg-gray-50 rounded-lg">

                  <p className="text-sm text-gray-600 mb-2">State Website:</p>

                  <p className="font-medium text-sm truncate select-none text-gray-800">{registrationResult.redirectUrl}</p>

                </div>



                <div className="flex justify-between">

                  <button

                    onClick={previousStep}

                    className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"

                  >

                    Back

                  </button>

                  <button

                    onClick={handleOpenStateWebsite}

                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"

                  >

                    Continue to State Website

                  </button>

                </div>

              </div>

            </div>

          )}



          {currentStep === 3 && currentFlow === 'reminders' && (
            <ElectionReminders
              engagementData={form}
              updateEngagementData={updateForm}
              onNext={nextStep}
              onPrevious={previousStep}
              setShowReturnFlow={setShowReturnFlow}
            />
          )}



          {currentStep === 3 && currentFlow === 'polling' && (

            <div className="bg-white rounded-xl shadow-lg p-6">

              <h2 className="text-2xl text-gray-900 font-semibold mb-2">Find Your Polling Location</h2>

              <p className="text-gray-600 text-sm mb-6">

                Access official polling location information for your address.

              </p>



              {pollingLocations.length > 0 && (<div className="mb-6">

                <div className="h-96 z-[99] rounded-lg overflow-hidden border border-gray-300">

                  <MapContainer

                    center={pollingLocations.length > 0 ? [pollingLocations[0].latitude, pollingLocations[0].longitude] : [30.2672, -97.7431]}

                    zoom={pollingLocations.length > 0 ? 14 : 12}

                    style={{ height: '100%', width: '100%' }}

                  >

                    <TileLayer

                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"

                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

                    />

                    <MapController

                      center={pollingLocations.length > 0 ? [pollingLocations[0].latitude, pollingLocations[0].longitude] : [30.2672, -97.7431]}

                      zoom={pollingLocations.length > 0 ? 14 : 12}

                    />

                    {pollingLocations.map((location, index) => (

                      <Marker key={index} position={[location.latitude, location.longitude]}>

                        <Popup>

                          <div className="p-2">

                            <h3 className="font-semibold text-sm mb-1">{location.address.locationName}</h3>

                            <p className="text-xs text-gray-600 mb-1">{location.address.line1}</p>

                            <p className="text-xs text-gray-600 mb-1">{location.address.city}, {location.address.state} {location.address.zip}</p>

                            {location.pollingHours && <p className="text-xs text-gray-500">Hours: {location.pollingHours}</p>}

                          </div>

                        </Popup>

                      </Marker>

                    ))}

                  </MapContainer>

                </div>

              </div>)}



              {/* Polling Locations List */}

              <div className="space-y-3 mb-6">

                <h3 className="font-semibold text-gray-900 mb-3">Nearby Polling Locations</h3>

                {isPollingLoading ? (

                  <div className="flex items-center justify-center py-8">

                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>

                    <span className="ml-3 text-gray-600">Finding polling locations...</span>

                  </div>

                ) : pollingLocations.length > 0 ? (

                  pollingLocations.map((location, index) => (

                    <div key={index} className="border border-gray-200 rounded-lg p-4">

                      <div className="flex justify-between items-start">

                        <div className="flex-1">

                          <h4 className="font-medium text-gray-900 mb-1">{location.address.locationName}</h4>

                          <p className="text-sm text-gray-600 mb-1">{location.address.line1}</p>

                          <p className="text-sm text-gray-600 mb-1">{location.address.city}, {location.address.state} {location.address.zip}</p>

                          {location.pollingHours && <p className="text-xs text-gray-500">Hours: {location.pollingHours}</p>}

                        </div>

                       

                      </div>

                    </div>

                  ))

                ) : (

                  <div className="text-center py-8 text-gray-500">

                    <MapIcon className="w-12 h-12 mx-auto mb-3 text-gray-300" />

                    <p>No polling locations found for your address.</p>

                    <button

                      onClick={() => refetchPollingLocations()}

                      className="mt-3 text-blue-600 hover:text-blue-800 text-sm font-medium"

                    >

                      Try Again

                    </button>

                    {pollingLocationsData?.data?.state?.[0]?.electionAdministrationBody?.votingLocationFinderUrl && (

                      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">

                        <p className="text-sm text-blue-800 mb-2">

                          For more polling location results, visit your state's official website:

                        </p>

                        <a

                          href={pollingLocationsData.data.state[0].electionAdministrationBody.votingLocationFinderUrl}

                          target="_blank"

                          rel="noopener noreferrer"

                          className="text-blue-600 hover:text-blue-800 underline text-sm font-medium"

                        >

                          {pollingLocationsData.data.state[0].electionAdministrationBody.votingLocationFinderUrl}

                        </a>

                      </div>

                    )}

                  </div>

                )}

              </div>



              {/* Compliance Note */}

              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">

                <p className="text-xs text-gray-600">

                  Polling information is provided by official election sources.

                </p>

              </div>



              <div className="flex justify-between">

                <button

                  onClick={() => {
                    setCurrentFlow(null);
                    setShowReturnFlow(true);
                  }}

                  className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"

                >

                  Back

                </button>

                <button

                  onClick={() => {

                    setShowConfirmation(true);

                    nextStep();

                  }}

                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"

                >

                  Complete

                </button>

              </div>

            </div>

          )}



          {currentStep === 3 && currentFlow === 'dates' && (
            <ElectionDates
              isElectionLoading={isElectionLoading}
              electionError={electionError}
              electionData={electionData}
              engagementData={form}
              onShowReturnFlow={() => setShowReturnFlow(true)}
              onNextStep={nextStep}
              onSetCurrentFlow={setCurrentFlow}
              onSetCurrentStep={setCurrentStep}
            />
          )}



          {currentStep === 4 && !showConfirmation && (

            <VoterPledge

              engagementData={form}

              updateEngagementData={updateForm}

              onNext={handlePledgeSubmit}

              isSubmitting={pledgeToVoteMutation.isPending}

              onPrevious={previousStep}

            />

          )}



          {currentStep === 4 && showConfirmation && (

            <ConfirmationSuccess

              engagementData={form}

              onFinish={endFlow}

            />

          )}



          {showRegistrationStatusPage && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-2xl p-8 shadow-2xl">

                <div className="text-center">

                  <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">What did you find on the official site?</h2>

                  <p className="text-gray-600 md:text-base text-sm mb-8">Please let us know your registration status</p>



                  <div className="space-y-4 mb-8">

                    <button

                      onClick={() => handleRegistrationStatusSelection('registered')}

                      className="w-full bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow flex items-center justify-between group"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">

                          <span className="text-green-600 font-bold">✓</span>

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">I'm registered</h3>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400 group-hover:text-gray-600" />

                    </button>



                    <button

                      onClick={() => handleRegistrationStatusSelection('not_registered')}

                      className="w-full bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow flex items-center justify-between group"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">

                          <span className="text-red-600 font-bold">✗</span>

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">I'm not registered</h3>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400 group-hover:text-gray-600" />

                    </button>



                    <button

                      onClick={() => handleRegistrationStatusSelection('not_sure')}

                      className="w-full bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow flex items-center justify-between group"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">

                          <span className="text-yellow-600 font-bold">!</span>

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">I'm not sure / I couldn't complete it</h3>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400 group-hover:text-gray-600" />

                    </button>

                  </div>



                  <div className="bg-gray-50 rounded-lg p-4">

                    <label className="flex items-center space-x-3">

                      <input

                        type="checkbox"

                        checked={contactOptInChecked}

                        onChange={(e) => setContactOptInChecked(e.target.checked)}

                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"

                      />

                      <span className="text-sm text-gray-700">

                        {smsRemindersEnabled

                          ? 'Can we text or email you a link to official state site?'

                          : 'Can we email you a link to official state site?'}

                      </span>

                    </label>

                    {contactOptInChecked && (

                      <div className="mt-3 text-xs text-gray-600 bg-white p-3 rounded border">

                        <p><strong>State:</strong> {form.state}</p>

                        <p><strong>Email:</strong> {form.email}</p>

                        {smsRemindersEnabled && <p><strong>Phone:</strong> {form.phone || 'Not provided'}</p>}

                      </div>

                    )}

                    <div className="text-xs text-gray-400 mt-2">

                      {smsRemindersEnabled

                        ? 'By checking this box, you consent to receive periodic text and email about voting information support from 123-Vote. Message and data rates may apply. Text STOP to opt out at any time. You may unsubscribe from email at any time.'

                        : 'By checking this box, you consent to receive periodic email about voting information support from 123-Vote. You may unsubscribe from email at any time.'}

                    </div>

                  </div>

                </div>

              </div>

            </div>

          )}



          {/* Return Flow Modal */}

          {showReturnFlow && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-2xl p-4 md:p-8 shadow-2xl">

                <div className="text-center">

                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-200 rounded-full mb-4">

                    <CheckCircleIcon fontSize="large" className="text-blue-600" />

                  </div>

                  <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                    {isFromNotSureFlow ? "Please proceed with the next steps" : "You are registered to Vote!"}
                  </h2>

                  <p className="text-gray-600 mb-8">What would you like to do next?</p>



                  <div className="space-y-4">

                    <div

                      onClick={() => registrationResult?.onlineVoteByMailAllowed && handleReturnFlowOption('vbm')}

                      className={`bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow flex items-center justify-between ${!registrationResult?.onlineVoteByMailAllowed ? " cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                    >

                      <div className="flex items-center gap-4">

                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">

                          <Mail className="text-blue-600" fontSize="medium" />

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">Vote by mail</h3>

                          <p className="text-sm text-gray-600">Request on the state site to vote by mail</p>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400" />

                    </div>

                    <div

                      onClick={() => handleReturnFlowOption('polling')}

                      className="bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow cursor-pointer flex items-center justify-between"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">

                          <MapIcon className="text-blue-600" fontSize="medium" />

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">Find My Polling Location</h3>

                          <p className="text-sm text-gray-600">See where to cast your ballot.</p>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400" />

                    </div>



                    <div

                      onClick={() => handleReturnFlowOption('reminders')}

                      className="bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow cursor-pointer flex items-center justify-between"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">

                          <NotificationsIcon className="text-green-600" fontSize="medium" />

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">Get Election Reminders</h3>

                          <p className="text-sm text-gray-600">Never miss a deadline or date.</p>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400" />

                    </div>



                    <div

                      onClick={() => handleReturnFlowOption('dates')}

                      className="bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow cursor-pointer flex items-center justify-between"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">

                          <CalendarMonthIcon className="text-purple-600" fontSize="medium" />

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">Learn About Voting Dates</h3>

                          <p className="text-xs text-gray-500 italic">Get information about voting dates in your state.</p>

                        </div>

                      </div>

                      <AddIcon className="text-gray-400" />

                    </div>



                    <div

                      onClick={() => handleReturnFlowOption('exit')}

                      className="bg-white border border-gray-200 rounded-xl p-3 md:p-6 hover:shadow-md transition-shadow cursor-pointer flex items-center justify-between"

                    >

                      <div className="flex items-center gap-4">

                        <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">

                          <ArrowForwardIcon className="text-gray-600" fontSize="medium" />

                        </div>

                        <div className="text-left">

                          <h3 className="font-semibold text-gray-900">Exit</h3>

                          <p className="text-sm text-gray-600">Complete and exit</p>

                        </div>

                      </div>

                      <ArrowForwardIcon className="text-gray-400" />

                    </div>

                  </div>

                </div>

              </div>

            </div>

          )}





          {/* Not Registered Modal */}

          {showNotRegisteredModal && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-md p-8 shadow-2xl">

                <div className="text-center">

                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">

                    <span className="text-red-600 text-2xl font-bold">✗</span>

                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">You're not registered yet</h2>

                  <p className="text-gray-600 mb-6">You can register on your state's official website</p>



                  <button

                    onClick={handleRegisterOnStateSite}

                    className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 mb-3"

                  >

                    Register on your state site

                  </button>



                  <button

                    onClick={() => setShowNotRegisteredModal(false)}

                    className="w-full px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"

                  >

                    Cancel

                  </button>

                </div>

              </div>

            </div>

          )}





          {/* Completion Check Modal */}

          {showCompletionCheckModal && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-md p-8 shadow-2xl">

                <div className="text-center">

                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">

                    <ErrorOutlineIcon className="text-blue-600" fontSize="large" />

                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">Did you complete registration?</h2>

                  <p className="text-gray-600 mb-6">Let us know if you were able to complete your registration</p>



                  <div className="space-y-3">

                    <button

                      onClick={() => handleCompletionCheckResponse(true)}

                      className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"

                    >

                      Yes, I completed registration

                    </button>



                    <button

                      onClick={() => handleCompletionCheckResponse(false)}

                      className="w-full px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"

                    >

                      No, I couldn't complete it

                    </button>

                  </div>

                </div>

              </div>

            </div>

          )}



          {/* Contact Opt-In Page */}

          {showContactOptIn && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-md p-8 shadow-2xl">

                <div className="text-center">

                  <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">

                    <ErrorOutlineIcon className="text-yellow-600" fontSize="large" />

                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">Need help with registration?</h2>

                  <p className="text-gray-600 mb-6">We can send you a link to your state's official registration site</p>



                  <div className="bg-gray-50 rounded-lg p-4 mb-6">

                    <p className="text-sm font-medium text-gray-700 mb-3">Your information:</p>

                    <p><strong>State:</strong> {form.state}</p>

                    <p><strong>Email:</strong> {form.email}</p>

                    {smsRemindersEnabled && <p><strong>Phone:</strong> {form.phone || 'Not provided'}</p>}

                  </div>



                  <label className="flex items-center space-x-3 mb-6">

                    <input

                      type="checkbox"

                      checked={contactOptInChecked}

                      onChange={(e) => setContactOptInChecked(e.target.checked)}

                      disabled={contactOptInMutation.isPending}

                      className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"

                    />

                    <span className="text-sm text-gray-700">

                      {smsRemindersEnabled

                        ? 'Can we text or email you a link to official state site?'

                        : 'Can we email you a link to official state site?'}

                    </span>

                  </label>



                  <div className="text-xs text-gray-400 mb-6">

                    {smsRemindersEnabled

                      ? 'By checking this box, you consent to receive periodic text and email about voting information support from 123-Vote. Message and data rates may apply. Text STOP to opt out at any time. You may unsubscribe from email at any time.'

                      : 'By checking this box, you consent to receive periodic email about voting information support from 123-Vote. You may unsubscribe from email at any time.'}

                  </div>



                  <div className="flex gap-3">

                    <button

                      onClick={handleContactOptInSkip}

                      disabled={contactOptInMutation.isPending}

                      className="w-full px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"

                    >

                      No, Proceed

                    </button>

                    <button

                      onClick={handleContactOptInSubmit}

                      disabled={!contactOptInChecked || contactOptInMutation.isPending}

                      className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"

                    >

                      {contactOptInMutation.isPending ? 'Submitting...' : 'Yes, Next'}

                    </button>

                  </div>

                </div>

              </div>

            </div>

          )}





          {/* VBM Completion Modal */}

          {showVBMCompletionModal && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-md p-8 shadow-2xl">

                <div className="text-center">

                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">

                    <Mail className="text-blue-600" fontSize="large" />

                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">What did you find on the state site?</h2>

                  <p className="text-gray-600 mb-6">Please let us know how it went</p>



                  <div className="space-y-3 mb-6">

                    <button

                      onClick={() => handleVBMCompletionResponse('requested')}

                      className="w-full px-4 py-3 border border-slate-300 text-black rounded-lg hover:bg-gray-100 transition-colors text-left flex items-center gap-3"

                    >

                      <CheckCircleIcon />

                      I requested a mail ballot

                    </button>

                    <button

                      onClick={() => handleVBMCompletionResponse('didnt_complete')}

                      className="w-full px-4 py-3  border border-slate-300 text-gray-800 rounded-lg hover:bg-gray-100 transition-colors text-left flex items-center gap-3"

                    >

                      <ErrorOutlineIcon />

                      I didn't complete it

                    </button>

                    <button

                      onClick={() => handleVBMCompletionResponse('not_eligible')}

                      className="w-full px-4 py-3 border border-slate-300 bg-white text-gray-800 rounded-lg hover:bg-gray-100 transition-colors text-left flex items-center gap-3"

                    >

                      <ErrorOutlineIcon />

                      I wasn't eligible / couldn't continue

                    </button>

                  </div>

                </div>

              </div>

            </div>

          )}



          {/* VBM Opt-in Modal */}

          {showVBMOptInModal && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-md p-8 shadow-2xl">

                <div className="text-center">

                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">

                    <Mail className="text-blue-600" fontSize="large" />

                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">Get Mail Ballot Updates</h2>

                  <p className="text-gray-600 mb-6">Choose the updates you'd like to receive (optional)</p>



                  <div className="space-y-3 mb-6 text-left">

                    <label className="flex items-start space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">

                      <input

                        type="checkbox"

                        checked={vbmOptIns.mailBallotReminders}

                        onChange={(e) => handleVBMOptInChange('mailBallotReminders', e.target.checked)}

                        className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"

                      />

                      <div>

                        <span className="font-medium text-gray-900">Get mail ballot reminders</span>

                        <p className="text-sm text-gray-600">Receive reminders about your mail ballot status</p>

                      </div>

                    </label>



                    <label className="flex items-start space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">

                      <input

                        type="checkbox"

                        checked={vbmOptIns.ballotTracking}

                        onChange={(e) => handleVBMOptInChange('ballotTracking', e.target.checked)}

                        className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"

                      />

                      <div>

                        <span className="font-medium text-gray-900">Check ballot tracking info</span>

                        <p className="text-sm text-gray-600">Track your mail ballot status and delivery</p>

                      </div>

                    </label>



                    <label className="flex items-start space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">

                      <input

                        type="checkbox"

                        checked={vbmOptIns.returnDeadlineReminders}

                        onChange={(e) => handleVBMOptInChange('returnDeadlineReminders', e.target.checked)}

                        className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"

                      />

                      <div>

                        <span className="font-medium text-gray-900">Get return deadline reminders</span>

                        <p className="text-sm text-gray-600">Get reminders about ballot return deadlines</p>

                      </div>

                    </label>

                  </div>



                  <button

                    onClick={handleVBMOptInSubmit}

                    className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"

                  >

                    Finish

                  </button>

                </div>

              </div>

            </div>

          )}



          {/* VBM Retry Modal */}

          {showVBMRetryModal && (

            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">

              <div className="bg-white rounded-2xl w-full max-w-md p-8 shadow-2xl">

                <div className="text-center">

                  <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">

                    <ErrorOutlineIcon className="text-yellow-600" fontSize="large" />

                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">Request Not Completed</h2>

                  <p className="text-gray-600 text-xs mb-6">

                    It looks like your request was not completed. You must complete your request on the state form for your ballot to be sent.

                  </p>



                  <div className="mb-6 p-4 bg-gray-50 rounded-lg">

                    <p className="text-sm text-gray-700 mb-2">State Ballot Request URL:</p>

                    <a

                      href={registrationResult.voteByMailUrl}

                      target="_blank"

                      rel="noopener noreferrer"

                      className="text-blue-600 hover:text-blue-800 text-sm break-all"

                    >

                      {registrationResult.voteByMailUrl}

                    </a>

                  </div>



                  <Button

                    onClick={handleVBMRetryReturn}

                    variant="primary"

                    size="extra-large"

                    label="Return to State Site"

                  />





                </div>

              </div>

            </div>

          )}

        </div>

      )}

    </section>

  );

}
